/**
 * Registers the settings forms the Inspector shows, through the editor's
 * seam — the editor knows no design system's prop vocabulary.
 */
import {
  registerWidgetQuickEdit,
  registerWidgetSettings,
} from "@website-builder/editor";

import {
  ButtonSettings,
  CardSettings,
  HeadingSettings,
  IconSettings,
  InputSettings,
} from "./forms.js";
import {
  ButtonQuick,
  CardQuick,
  HeadingQuick,
  IconQuick,
  InputQuick,
} from "./quickForms.js";

export function registerWidgetSettingsForms(): void {
  registerWidgetSettings("button", ButtonSettings);
  registerWidgetSettings("heading", HeadingSettings);
  registerWidgetSettings("card", CardSettings);
  registerWidgetSettings("input", InputSettings);
  registerWidgetSettings("icon", IconSettings);
  registerWidgetQuickEdit("button", ButtonQuick);
  registerWidgetQuickEdit("heading", HeadingQuick);
  registerWidgetQuickEdit("card", CardQuick);
  registerWidgetQuickEdit("input", InputQuick);
  registerWidgetQuickEdit("icon", IconQuick);
}
